import React from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';
import ButtonBase from '@material-ui/core/ButtonBase';
import MultiSelect from 'UI/multiSelect';
import DateRangeSelection from 'UI/dateRangeSelection';
import TravellerSelection from 'UI/travellerSelection';
import Checkbox from 'UI/checkbox';
import DateButton from 'UI/dateButton';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from 'UI/button';
import Footer from 'UI/footer';
import LabelInput from 'UI/labelInput';
import DeleteIcon from '@material-ui/icons/Delete';

const BasicTripDetails = ({
  classes,
  origin,
  places,
  suggestions,
  tripDates,
  tripDate,
  roomings,
  flightsBooked,
  flightArrivalDateTime,
  flightDepartureDateTime,
  errorMsg,
  isLoading,
  enableAI,
  noLandPackage,
  onRemoveHandler,
  onSearchChange,
  onItemSelection,
  onDateSelection,
  onRoomingChange,
  onChildAgeChange,
  onRemoveRoom,
  onFlightArrivalDateTimeChange,
  onFlightDepartureDateTimeChange,
  onChange,
  onAddRoom,
  onValidityChecker,
  onTabChange,
  onSubmitHandler,
}) => {
  return (
    <div className={classes.body}>
      <div className={classes.row}>
        <MultiSelect
          extraClass={classes.wrapperLeft}
          inputClass={classes.input}
          label="Origin city"
          selections={origin.items}
          value={origin.value}
          accessor="name"
          renderType="place"
          data={suggestions.cities}
          removeHandler={(item) => onRemoveHandler({ field: 'origin', accessor: 'displayName', item })}
          onChange={(val) => onSearchChange({ field: 'origin', searchType: 'cities', value: val })}
          onSelected={(item) => onItemSelection({ field: 'origin', accessor: 'displayName', item })}
        />
        <MultiSelect
          extraClass={classes.wrapperRight}
          inputClass={classes.input}
          label="Destination"
          selections={places.items}
          value={places.value}
          accessor="name"
          renderType="place"
          data={places.value ? suggestions.destinations : []}
          removeHandler={(item) => onRemoveHandler({ field: 'places', accessor: 'displayName', item })}
          onChange={(val) => onSearchChange({ field: 'places', searchType: 'places', value: val })}
          onSelected={(item) => onItemSelection({ field: 'places', accessor: 'displayName', item })}
        />
      </div>
      <div className={classes.row} style={{ alignItems: 'flex-start' }}>
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          paddingRight: 20,
        }}
        >
          {
            noLandPackage ? null : (
              <>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
                >
                  <div style={{ width: '280px' }} className={classes.childLabel}>ROOMS & GUESTS</div>
                  {
                    roomings.some((rooming) => { return rooming.children > 0; })
                      ? <div className={classes.childLabel}>CHILD 1 AGE</div>
                      : null
                  }
                  {
                    roomings.some((rooming) => { return rooming.children > 1; })
                      ? <div className={classes.childLabel}>CHILD 2 AGE</div>
                      : null
                  }
                  {
                    roomings.some((rooming) => { return rooming.children > 2; })
                      ? <div className={classes.childLabel}>CHILD 3 AGE</div>
                      : null
                  }
                </div>
                {roomings.map((rooming, roomIndex) => {
                  return (
                    <div
                      // eslint-disable-next-line react/no-array-index-key
                      key={roomIndex}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        marginLeft: -30,
                        marginBottom: 10,
                      }}
                    >
                      <ButtonBase
                        onClick={() => onRemoveRoom({ roomIndex })}
                        style={{
                          padding: 5,
                          borderRadius: 4,
                          cursor: 'pointer',
                          visibility: roomIndex > 0 ? 'visible' : 'hidden',
                        }}
                      >
                        <DeleteIcon className={classes.deleteIcon} />
                      </ButtonBase>
                      <div style={{
                        width: '60px', marginRight: 10, fontWeight: 'bold',
                      }}
                      >
                        Room {roomIndex + 1}
                      </div>
                      <TravellerSelection
                        extraClass={classes.travellerSelection}
                        travellers={rooming}
                        onChange={(val) => onRoomingChange({ roomIndex, value: val })}
                        maxAdults={3}
                        maxChildren={3}
                        maxInfants={3}
                      />
                      {
                        rooming.children > 0 && (() => {
                          const dropdowns = [];
                          for (let index = 0; index < rooming.children; index++) {
                            const ageValue = rooming.childrenAges && rooming.childrenAges[index];
                            // Normalize value: must be between 2-12 or empty string
                            const normalizedValue = (ageValue && ageValue >= 2 && ageValue <= 12) ? ageValue : '';
                            dropdowns.push(
                              <div key={index} className={classes.ageDropdownWrapper}>
                                <FormControl className={classes.ageDropdown}>
                                  <Select
                                    value={normalizedValue}
                                    onChange={(e) => onChildAgeChange({ roomIndex, childIndex: index, age: e.target.value })}
                                    className={classes.ageSelect}
                                    variant="outlined"
                                    size="small"
                                    displayEmpty
                                  >
                                    <MenuItem value="" disabled>
                                      -
                                    </MenuItem>
                                    {(() => {
                                      const ageOptions = [];
                                      for (let age = 2; age <= 12; age++) {
                                        ageOptions.push(
                                          <MenuItem key={age} value={age}>
                                            {age} yr
                                          </MenuItem>
                                        );
                                      }
                                      return ageOptions;
                                    })()}
                                  </Select>
                                </FormControl>
                              </div>
                            );
                          }
                          return dropdowns;
                        })()
                      }
                    </div>
                  );
                })}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onAddRoom}
                  className={classes.addRoomButton}
                >
                  + Add Room
                </Button>
              </>
            )
          }
        </div>
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
        >
          <LabelInput
            label="TRIP DATES"
            extraClass={classes.wrapperRight}
            containerStyle={{ marginLeft: 0 }}
          >
            <DateRangeSelection
              value={`${tripDate}${tripDates.from && tripDates.to ? ` (${moment(tripDates.to).diff(tripDates.from, 'days')}N)` : ''}`}
              dates={tripDates}
              onSelected={(date, dateStr) => onDateSelection({ date, dateStr })}
            />
          </LabelInput>
          <div
            className={classes.itemRow}
            style={{
              marginTop: 20,
              width: '100%',
              justifyContent: 'space-between',
              display: noLandPackage ? 'none' : 'flex',
            }}
          >
            <Checkbox
              disabled={false}
              checked={flightsBooked}
              label="Flights booked"
              onChange={() => onChange({ field: 'flightsBooked', value: !flightsBooked })}
              rootClass={classes.checkbox}
            />

            <MuiPickersUtilsProvider utils={MomentUtils}>
              <LabelInput
                label="ARRIVAL DATE/TIME (OPT.)"
                extraClass={classes.wrapperRight}
                containerStyle={{
                  marginLeft: 0,
                  marginBottom: 15,
                  alignItems: 'center',
                  maxWidth: '30%',
                  visibility: flightsBooked ? 'visible' : 'hidden',
                }}
              >
                <DateButton
                  value={flightArrivalDateTime}
                  onChange={(date) => onFlightArrivalDateTimeChange({ date })}
                  askTime
                  format="DD MMM YY, hh:mm A"
                  disablePast
                  minDate={tripDates.from ? moment(tripDates.from).subtract(1, 'days').toDate() : undefined}
                  maxDate={tripDates.to ? moment(tripDates.to).add(1, 'days').toDate() : undefined}
                  extraClass={classes.dateButton}
                />
              </LabelInput>
              <LabelInput
                label="DEPARTURE DATE/TIME (OPT.)"
                extraClass={classes.wrapperRight}
                containerStyle={{
                  marginLeft: 0,
                  marginBottom: 15,
                  alignItems: 'center',
                  maxWidth: '30%',
                  visibility: flightsBooked ? 'visible' : 'hidden',
                }}
              >
                <DateButton
                  value={flightDepartureDateTime}
                  onChange={(date) => onFlightDepartureDateTimeChange({ date })}
                  askTime
                  format="DD MMM YY, hh:mm A"
                  disablePast
                  minDate={tripDates.from ? moment(tripDates.from).subtract(1, 'days').toDate() : undefined}
                  maxDate={tripDates.to ? moment(tripDates.to).add(1, 'days').toDate() : undefined}
                  extraClass={classes.dateButton}
                />
              </LabelInput>
            </MuiPickersUtilsProvider>
          </div>
        </div>
      </div>
      <Footer errorMsg={errorMsg} extraClass={classes.footerFlexEnd}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {enableAI ? (
          <Button
            loading={isLoading}
            onClick={() => {
              if (!onValidityChecker(true, 'Basic Trip Details').error) {
                onTabChange('Customisations');
              }
            }}
          >
            Next
          </Button>
        ) : (
          <Button
            loading={isLoading}
            disabled={!!errorMsg}
            onClick={() => {
              if (noLandPackage) {
                window.localStorage.setItem('shouldCallChatAgent', 'false');
                onSubmitHandler({ ignoreTemplate: true });
              } else {
                onTabChange('Select Template');
              }
            }}
          >
            {noLandPackage ? 'Create' : 'Next'}
          </Button>
        )}
      </Footer>
    </div>
  );
};

BasicTripDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  origin: PropTypes.object.isRequired,
  places: PropTypes.object.isRequired,
  suggestions: PropTypes.object.isRequired,
  tripDates: PropTypes.object.isRequired,
  tripDate: PropTypes.string.isRequired,
  roomings: PropTypes.array.isRequired,
  flightsBooked: PropTypes.bool.isRequired,
  flightArrivalDateTime: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  flightDepartureDateTime: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  errorMsg: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  enableAI: PropTypes.bool.isRequired,
  noLandPackage: PropTypes.bool,
  onRemoveHandler: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onItemSelection: PropTypes.func.isRequired,
  onDateSelection: PropTypes.func.isRequired,
  onRoomingChange: PropTypes.func.isRequired,
  onChildAgeChange: PropTypes.func.isRequired,
  onRemoveRoom: PropTypes.func.isRequired,
  onFlightArrivalDateTimeChange: PropTypes.func.isRequired,
  onFlightDepartureDateTimeChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onAddRoom: PropTypes.func.isRequired,
  onValidityChecker: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
};

export default BasicTripDetails;
